/**
 * Chat API Service
 * Handles REST API interactions for the chat application
 */

import { fetchApi } from '../utils/api';

/**
 * Chat-specific API methods
 */
export const chatApi = {
  /**
   * Send a message via the REST API
   * @param {Object} message - Message data
   * @returns {Promise<Object>} - API response
   */
  sendMessage: async (message) => {
    // Get authentication token
    const token = localStorage.getItem('token');
    
    // Add authentication information to the message
    const messageWithAuth = {
      ...message,
      is_authenticated: !!token,
      auth_token: token
    };
    
    return fetchApi('webchat/message', {
      method: 'POST',
      body: JSON.stringify(messageWithAuth)
    });
  }
};
